import type { Router } from "vue-router";

const RELOAD_TARGET_KEY = "missing-route-chunk-reload-target";

const isChunkLoadError = (error: unknown): boolean =>
  error instanceof Error &&
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk \S+ failed|Unable to preload CSS/i.test(
    error.message,
  );

export const installChunkRecovery = (
  router: Router,
  storage?: Storage,
  navigate: (href: string) => void = (href) => window.location.assign(href),
): void => {
  router.onError((error, to) => {
    if (!isChunkLoadError(error)) return;

    const href = router.resolve(to).href;
    try {
      const tabStorage = storage ?? window.sessionStorage;
      if (tabStorage.getItem(RELOAD_TARGET_KEY) === href) return;
      tabStorage.setItem(RELOAD_TARGET_KEY, href);
    } catch {
      // Without tab storage, a failed reload could repeat indefinitely.
      return;
    }

    navigate(href);
  });

  router.afterEach((to, _from, failure) => {
    if (failure) return;

    try {
      const tabStorage = storage ?? window.sessionStorage;
      if (tabStorage.getItem(RELOAD_TARGET_KEY) === router.resolve(to).href) {
        tabStorage.removeItem(RELOAD_TARGET_KEY);
      }
    } catch {
      // The recovery path is disabled when tab storage is unavailable.
    }
  });
};
